import { useState } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import "../assets/css/--component-breadcrumbs.css"
import BreadCrumbTranslation from "../data/breadcrumbs-locale";

function Breadcrumbs({pageTile,breadcrumbItems=[]}){
    const [language, setLanguage] = useState("en")
    useEffect(()=>{
        const lang = localStorage.getItem("LANG")
        if(lang && lang.length){
            const l = lang === "ar" ? "ar" : "en"
            setLanguage(l)
            document.title = pageTile.length ? `${BreadCrumbTranslation(pageTile,l)} | ${BreadCrumbTranslation('Main Country Grill and Store',l)}` : BreadCrumbTranslation('Main Country Grill and Store',l)
        }
        else{
            document.title = pageTile.length ? `${BreadCrumbTranslation(pageTile,"en")} | ${BreadCrumbTranslation('Main Country Grill and Store',"en")}` : BreadCrumbTranslation('Main Country Grill and Store',"en")
        }
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    },[])
    return (
        <div className="breadcrumbs">
            <div className="wrapper">
                {
                    breadcrumbItems.map((e,key)=>(
                        e.link.length ? <Link key={key} to={e.link}>{BreadCrumbTranslation(e.title,language)}</Link> : <span key={key}>{BreadCrumbTranslation(e.title,language)}</span>
                    ))
                }
            </div>
        </div>
    )
}

export default Breadcrumbs;